(function () {
  angular
    .module('kareo.ui.shared.directives.patient-create', [
      'kareo.ui.shared.directives.k-edit-patient',
      'kareo.ui.shared.directives.patient-create.services',
      'kareo.ui.shared.directives.templates'
    ])
    .directive('patientCreateModal', patientCreateModal);

  function patientCreateModal() {
    return {
      bindToController: true,
      controller,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {}, // avoid inheriting parent scope
      template: require('./patient-create-modal.pug')()
    };
  }

  controller.$inject = ['$scope', 'PatientCreateModalService'];

  function controller($scope, PatientCreateModalService) {
    var vm = this;

    vm.isOpen = false;
    vm.onCancel = onCancel;
    vm.onSuccess = onSuccess;

    $scope.$watch(PatientCreateModalService.isOpen, (isOpen) => {
      vm.isOpen = isOpen;
    });

    function onCancel() {
      PatientCreateModalService.close();
    }

    function onSuccess(patient) {
      PatientCreateModalService.patientCreated(patient);
    }
  }
})();
